import React, { ForwardedRef, useImperativeHandle, useMemo, useRef } from 'react';
import Chart from '..';
import { LineChartProps, ChartRef } from '../_config/interface';
import { makeupOptions } from '../_config/utils';

const LineChartInner: React.ForwardRefRenderFunction<ChartRef, LineChartProps> = (
  props,
  ref: ForwardedRef<ChartRef>,
) => {
  const {
    className = '',
    style = {},
    height,
    nowTime,
    preTime,
    isMultipleCompetitor,
    hasDataZoom,
    chartEventConfig,
    notMerge,
    lineOption,
    onChartEarliestClick,
    ifLineChartLegendOn = false,
    chartType = 'line',
    setLegendSelectedFalse,
  } = props;

  // console.log('LineChartInner', props);

  const chartRef = useRef<ChartRef>(null);
  const option = makeupOptions(props, 'line');
  // 获取实例
  const instance = () => {
    return chartRef?.current?.instance();
  };

  // 对父组件暴露的方法
  useImperativeHandle(ref, () => ({
    instance,
  }));

  const chartStyle = {
    ...(height ? { height: `${height}px` } : {}),
    width: '100%',
    position: isMultipleCompetitor ? 'relative' : 'static',
    ...style,
  };

  return (
    <div className={`chart-box ${className}`} style={chartStyle}>
      <Chart
        ref={chartRef}
        option={lineOption ? lineOption : option}
        hasDataZoom={hasDataZoom}
        chartEventConfig={chartEventConfig}
        notMerge={notMerge}
        onChartEarliestClick={onChartEarliestClick}
        ifLineChartLegendOn={ifLineChartLegendOn}
        chartType={chartType}
        setLegendSelectedFalse={setLegendSelectedFalse}
      />
      {isMultipleCompetitor && (
        <div
          style={{
            position: 'absolute',
            bottom: '0px',
            left: '3%',
            opacity: 0.45,
          }}
        >
          <p style={{ marginBottom: '8px', fontSize: '12px' }}>{nowTime}</p>
          <p style={{ fontSize: '12px' }}>{preTime}</p>
        </div>
      )}
    </div>
  );
};

const LineChart = React.forwardRef(LineChartInner);

export default LineChart;
